import updateContent from 'owa-editor/lib/actions/updateContent';
import { findComposePlugins } from 'owa-mail-compose-store/lib/plugins/ComposePlugins';
export var getBody = function (viewState) { return function () {
    return viewState.content;
}; };
export var setBody = function (viewState) { return function (content, bodyType) {
    updateContent(viewState, content);
    if (viewState.bodyType == 'HTML') {
        var composePlugins = findComposePlugins(viewState);
        composePlugins.addinPlugin.updateContent(content, bodyType);
    }
}; };
export var getBodyType = function (viewState) { return function () {
    return viewState.bodyType;
}; };
export var prependBody = function (viewState) { return function (content) {
    var addinPlugin = findComposePlugins(viewState).addinPlugin;
    addinPlugin.prependContent(content);
    updateContent(viewState, addinPlugin.getContent());
}; };
export var getBodySelectedData = function (viewState) { return function () {
    if (!isEditorLastFocusedControl(viewState)) {
        return null;
    }
    var addinPlugin = findComposePlugins(viewState).addinPlugin;
    return addinPlugin.getSelectedData();
}; };
export var setBodySelectedData = function (viewState) { return function (content) {
    var addinPlugin = findComposePlugins(viewState).addinPlugin;
    addinPlugin.setSelectedData(content);
    updateContent(viewState, addinPlugin.getContent());
}; };
function isEditorLastFocusedControl(viewState) {
    return viewState.lastFocusedControl === 7 /* Editor */;
}
//# sourceMappingURL=BodyAdapter.js.map